// extracted by mini-css-extract-plugin
export default {"wrapper":"inlie-message_wrapper__bHXQZ","error":"inlie-message_error__KA+2I"};